import * as fromScene from '../../../actions/AdmMapa/Escenarios/Escenarios.actions';


export interface SceneState {
  Ejecutando: boolean;
  Scenes: any[] | null;
  errorMessage: any | null;
}

export const initialState: SceneState = {
    Ejecutando: false,
    Scenes: null,
    errorMessage: null
  };

export function sceneReducer(state = initialState, action: fromScene.SceneAcciones): SceneState {
    switch (action.type) {
      case fromScene.SceneATypes.SCENE_GET: {
          return {
            ...state,
            Ejecutando: true,
            Scenes: null,
            errorMessage: null
          };
      }
      case fromScene.SceneATypes.SCENE_SUCCESS: {
        return {
          ...state,
          Ejecutando: false,
          Scenes: action.Scenes,
          errorMessage: null
        };
      }
      case fromScene.SceneATypes.SCENE_FAILURE: {
        return {
          ...state,
          Scenes: null,
          errorMessage: {...action.payload.error}
        };
      }
      default: {
        return state;
      }
    }
  }
